import React from 'react';
import { HeartIcon, UsersIcon, TrendingUpIcon } from 'lucide-react';
export function OurMission() {
  const coreValues = ['Extreme Ownership', 'Constant and Never-Ending Improvement', 'Stewardship'];
  return <section className="section-padding bg-white" data-id="element-752">
      <div className="container-custom" data-id="element-753">
        <div className="max-w-4xl mx-auto" data-id="element-754">
          <div className="text-center mb-12" data-id="element-755">
            <h2 className="mb-6" data-id="element-756">Our Mission</h2>
          </div>

          <div className="bg-navy rounded-2xl p-12 text-center mb-12 border-2 border-navy" data-id="element-757">
            <p className="text-body-large text-white leading-relaxed font-medium" data-id="element-758">
              We exist to{' '}
              <span className="text-slate font-bold" data-id="element-759">
                fix the broken recruiting cycle in D2D sales
              </span>
              . We help companies build stable, scalable teams.
            </p>
          </div>

          <div className="bg-gray-50 rounded-2xl p-12 mb-12 border-2 border-gray-200" data-id="element-760">
            <p className="text-body-large leading-relaxed mb-6" data-id="element-761">
              We believe door-to-door sales remains one of the most effective
              environments for developing grit, refined communication skills,
              leadership, and financial freedom.
            </p>
            <p className="font-semibold" data-id="element-762">We take that seriously.</p>
          </div>

          <div className="mb-16" data-id="element-763">
            <h3 className="text-center mb-8" data-id="element-764">Our Core Values</h3>
            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-gray-200" data-id="element-765">
              <ul className="space-y-4" data-id="element-766">
                {coreValues.map((value, index) => <li key={index} className="flex items-center text-lg" data-id="element-767">
                    <span className="w-8 h-8 bg-slate/10 rounded flex items-center justify-center mr-4 flex-shrink-0" data-id="element-768">
                      <span className="text-slate font-bold" data-id="element-769">{index + 1}</span>
                    </span>
                    <span className="font-semibold text-navy" data-id="element-770">{value}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-771">
            <div className="text-center" data-id="element-772">
              <div className="w-16 h-16 bg-slate/10 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-773">
                <HeartIcon className="h-8 w-8 text-slate" data-id="element-774" />
              </div>
              <h3 className="mb-3" data-id="element-775">Integrity-Driven</h3>
              <p data-id="element-776">We do the right thing, even when it's hard.</p>
            </div>
            <div className="text-center" data-id="element-777">
              <div className="w-16 h-16 bg-slate/10 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-778">
                <UsersIcon className="h-8 w-8 text-slate" data-id="element-779" />
              </div>
              <h3 className="mb-3" data-id="element-780">People-First</h3>
              <p data-id="element-781">We give young people a real shot at a career.</p>
            </div>
            <div className="text-center" data-id="element-782">
              <div className="w-16 h-16 bg-slate/10 rounded-xl flex items-center justify-center mx-auto mb-4" data-id="element-783">
                <TrendingUpIcon className="h-8 w-8 text-slate" data-id="element-784" />
              </div>
              <h3 className="mb-3" data-id="element-785">Results-Focused</h3>
              <p data-id="element-786">We don't stop until the system works.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}